import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api';

// Configure Axios to automatically send JWT
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('imoonusel_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false); // New state to track authentication status

  // Check authentication status on mount
  useEffect(() => {
    const checkAuth = () => {
      const storedUser = localStorage.getItem('imoonusel_admin_user');
      const accessToken = localStorage.getItem('imoonusel_access_token');
      const refreshToken = localStorage.getItem('imoonusel_refresh_token');

      if (storedUser && accessToken && refreshToken) {
        try {
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true);
        } catch (e) {
          console.error("Failed to parse stored user data:", e);
          logout(); // Clear potentially corrupted data
        }
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login.php`, {
        email,
        password
      });

      if (response.data && response.data.user && response.data.access_token && response.data.refresh_token) {
        const { user: userData, access_token, refresh_token } = response.data;
        
        setUser(userData);
        setIsAuthenticated(true);
        localStorage.setItem('imoonusel_admin_user', JSON.stringify(userData));
        localStorage.setItem('imoonusel_access_token', access_token);
        localStorage.setItem('imoonusel_refresh_token', refresh_token);
        
        return { success: true };
      } else {
        return { success: false, message: response.data.message || 'Login failed' };
      }
    } catch (error) {
      console.error("Login Error:", error);
      const msg = error.response?.data?.message || 'Connection error';
      return { success: false, message: msg };
    }
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('imoonusel_admin_user');
    localStorage.removeItem('imoonusel_access_token');
    localStorage.removeItem('imoonusel_refresh_token');
    // Optional: Call API logout endpoint to invalidate tokens on server if implemented
  };

  // Function to refresh access token using refresh token (to be implemented later)
  const refreshAccessToken = async () => {
    // This would involve sending the refresh token to a backend endpoint
    // and receiving a new access token.
    // For now, it's a placeholder.
    console.warn("Refresh token functionality not yet implemented.");
    return false;
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout, loading, refreshAccessToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

